import { render, staticRenderFns } from "./AIList.vue?vue&type=template&id=e52b836a&scoped=true"
import script from "./AIList.vue?vue&type=script&lang=ts"
export * from "./AIList.vue?vue&type=script&lang=ts"
import style0 from "./AIList.vue?vue&type=style&index=0&id=e52b836a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b836a",
  null
  
)

/* custom blocks */
import block0 from "./AIList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports